module.exports = __webpack_public_path__ + "img/1f616.080db97.svg";